import { Skeleton, Stack } from '@mui/material';
import ListItemText from '@mui/material/ListItemText';
import React from 'react';

const SearchCardSkeleton = () => {
	return (
		<Stack
			justifyContent='space-between'
			direction='row'
			sx={{ width: '100%' }}
		>
			<ListItemText
				primary={<Skeleton width={240} />}
				secondary={<Skeleton width={160} />}
			/>
		</Stack>
	);
};

export default SearchCardSkeleton;
